import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta05Model } from './model-consultaSeguimentoPergunta05'

export const convertConsultaSeguimentoPergunta05ToInput = (
  value: ConsultaSeguimentoPergunta05Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_05_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_05_EXEMPLOS?.PASSOU.OLHA_PARA_AS_MAOS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_03,
      stResposta: convertSimNaoEnumToBoolean(
        value.PERGUNTA_05_EXEMPLOS?.PASSOU.MOVE_OS_DEDOS_QUANDO_BRINCA_DE_ESCONDER_ROSTO
      ),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_05_EXEMPLOS?.FALHOU.MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_05,
      stResposta: convertSimNaoEnumToBoolean(
        value.PERGUNTA_05_EXEMPLOS?.FALHOU.MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS
      ),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_05_EXEMPLOS?.FALHOU.AGITA_AS_MAOS_PERTO_DO_ROSTO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_05_EXEMPLOS?.FALHOU.AGITA_AS_MAOS_PERTO_DO_ROSTO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_08,
      stResposta: convertSimNaoEnumToBoolean(value.OUTRO?.radioValue),
      outros: value.OUTRO?.textValue,
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_05_09,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_05_DUAS_VEZES_POR_SEMANA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
